import styled from "styled-components";
import styleConst from "constants/style";
import background from "assets/images/svg/sign_in_background.svg";
import logo from "assets/images/svg/logo_full.svg";

export const Background = styled.div`
  display: flex;
  background-image: url(${background});
  background-repeat: no-repeat;
  background-size: cover;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
`;

export const Container = styled.div`
  display: inline-block;
  width: 360px;
  min-height: 450px;
  padding: 40px 27px;
  box-shadow: 5px 20px 30px ${styleConst.colors.shadow};
  border-radius: 10px;
  background-color: ${styleConst.colors.white};
  justify-content: center;
`;

export const InnerWrapper = styled.div`
  flex: 1;
  height: 200;
  padding-top: 8px;
`;

export const LogoContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 22px;
`;

export const Logo = styled.img.attrs({ src: logo })``;

export const LoadContainer = styled.div`
  display: flex;
  flex: 1;
  align-content: center;
  justify-content: center;
  margin-top: 100px;
`;

export const ItemWrapper = styled.div`
  margin-top: 34px;
  text-align: center;
`;
